import React, { useEffect, useState } from "react";
import { PageLoader, StatusBadge } from "../../components/shared";
import { Button } from "../../components/ui/button";
import { Tabs, TabsList, TabsTrigger } from "../../components/ui/tabs";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "../../components/ui/dropdown-menu";
import { DotsThreeVertical } from "@phosphor-icons/react";
import { toast } from "sonner";
import api, { apiErr } from "../../lib/api";

export default function AdminUsers() {
  const [role, setRole] = useState("customer");
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => { setLoading(true); api.get(`/admin/users?role=${role}`).then((r) => setUsers(r.data.users)).finally(() => setLoading(false)); };
  useEffect(() => { load(); }, [role]);

  const act = async (uid, action) => {
    try { const { data } = await api.post(`/admin/users/${uid}/${action}`); toast.success(data.message); load(); }
    catch (e) { toast.error(apiErr(e)); }
  };

  return (
    <div>
      <div className="overline mb-1">People</div>
      <h1 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight mb-6">Users</h1>
      <Tabs value={role} onValueChange={setRole}>
        <TabsList className="mb-6"><TabsTrigger value="customer">Customers</TabsTrigger><TabsTrigger value="organizer">Organizers</TabsTrigger></TabsList>
      </Tabs>
      {loading ? <PageLoader /> : (
        <div className="rounded-xl border border-border bg-card divide-y divide-border">
          {users.map((u) => (
            <div key={u.id} className="flex items-center justify-between p-4" data-testid={`user-${u.id}`}>
              <div>
                <div className="font-medium">{u.name} {u.email_verified && <span className="text-xs text-emerald-600">✓</span>}</div>
                <div className="text-sm text-muted-foreground">{u.email} · {u.mobile || "no mobile"}</div>
              </div>
              <div className="flex items-center gap-3">
                <StatusBadge status={u.status} />
                <DropdownMenu>
                  <DropdownMenuTrigger asChild><button className="w-8 h-8 grid place-items-center rounded-lg border border-border" data-testid={`user-menu-${u.id}`}><DotsThreeVertical size={16} /></button></DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuItem onClick={() => act(u.id, "reactivate")}>Activate</DropdownMenuItem>
                    <DropdownMenuItem onClick={() => act(u.id, "suspend")}>Suspend</DropdownMenuItem>
                    <DropdownMenuItem onClick={() => act(u.id, "block")} className="text-destructive">Block</DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </div>
            </div>
          ))}
          {users.length === 0 && <div className="p-8 text-center text-muted-foreground text-sm">No {role}s yet.</div>}
        </div>
      )}
    </div>
  );
}
